import { inchesToMm } from '@/common/helpers/formatUtilities'

/**
 * Reads the value each sortable part library column sorts by, keyed by column id.
 * Columns not listed here sort by the row field with the same name.
 *
 * @type {Object<string, (part: Object) => *>}
 */
export const PART_LIBRARY_SORT_VALUES = {
    // The product of the dimensions the Bounds cell shows, under the same condition, in mm so
    // imperial and metric parts compare correctly.
    bounds: (part) => {
        if (!part.minimumBoundBoxWidth || !part.minimumBoundBoxHeight) return undefined
        const dimensions = part.profile
            ? [part.rotaryProfileWidth, part.rotaryProfileLength, part.rotaryPartLength]
            : [
                  part.displayBoundBoxWidth ?? part.minimumBoundBoxWidth,
                  part.displayBoundBoxHeight ?? part.minimumBoundBoxHeight,
              ]
        return dimensions.reduce((size, value) => size * (part.isImperial ? inchesToMm(value) : value), 1)
    },
    cuttingTechnology: (part) => part.cuttingTechnology?.name,
    materialThickness: (part) => [part.material?.materialName, part.thickness],
    secondaryProcess: (part) =>
        [
            part.numberOfFolds > 0 ? 'Folding' : '',
            ...(part.partLibraryEntrySecondaryProcesses ?? []).map((process) => process.secondaryProcess?.name),
        ]
            .filter(Boolean)
            .join(', '),
    lastQuote: (part) => part.lastQuote?.lastModifiedDate,
    lastPrice: (part) => part.lastQuote?.lastPrice,
    lastQuantity: (part) => part.lastQuote?.lastQuantity,
}
